<!-- CONTENT 1: ESTADO DE SU ENVIO -->
<div class="container">
  <div class="row">
    <common-retry-search></common-retry-search>

    <!-- BLOQUE 1 -->
    <div class="col-12 offset-md-1 col-md-10 row">
      <!-- <h4>
      ESTADO DE SU ENVÍO
    </h4> -->
      <div class="well col-10 offset-1 offset-md-3 col-md-6" style="border:none">
        <h4 style="color:#d40511; font-size:24px; font-weight:bold">{{'NoData.NoInfo' | translate}}</h4>
      </div>
    </div>
  </div>
</div>

<!-- CONTENT 2: COMPROBACION ERRORES USUARIO -->
<div class="container">
  <div class="row">
    <div class="col-12 offset-md-3 col-md-6 erroresUsuario">
      <ul>
        <li class="tick">
          <span>{{'NoData.FirstCheckListInfo' | translate}}</span>
        </li>
        <ng-container *ngIf="'NoData.ListaComp3' | translate">
          <br>
          <li class="tick">
            <span>{{'NoData.ListaComp3' | translate}}</span>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>

<!-- CONTENT 4: CONTACTO -->
<div class="moduloContacto">
  <div class="row">
    <div class="col-12 offset-md-3 col-md-6 noEstar">
      <p style="font-weight:bold;">
        {{'Shared.TextContact1' | translate}}
        <br /> {{'Shared.TextContact2' | translate}}
      </p>
    </div>
    <div class="col-12 offset-sm-3 col-sm-6 btnSentStatus d-grid">
      <a href="{{'Shared.RouteUrlContact' | translate}}"
       target="_blank"
       class="btn btn-default btn-block"
       style="width: revert-layer;"
       (click)="sesion.enviarEventoGoogleAnalitics(categoriasGoogleAnalytics.Otros, 'Contacto');">
       {{'Shared.Contact' | translate}}
      </a>
    </div>
  </div>
</div>
